import type { CurrencyAmount, GameState } from "./types";

export function amount(value: CurrencyAmount): bigint {
  if (!/^-?\d+$/.test(value)) throw new Error(`Invalid integer amount: ${value}`);
  return BigInt(value);
}

export function addAmounts(left: CurrencyAmount, right: CurrencyAmount): CurrencyAmount {
  return (amount(left) + amount(right)).toString();
}

export function subtractAmounts(left: CurrencyAmount, right: CurrencyAmount): CurrencyAmount {
  return (amount(left) - amount(right)).toString();
}

export function multiplyAmount(value: CurrencyAmount, multiplier: number): CurrencyAmount {
  if (!Number.isSafeInteger(multiplier) || multiplier < 0) {
    throw new Error("Multiplier must be a non-negative safe integer");
  }
  return (amount(value) * BigInt(multiplier)).toString();
}

export function cloneState(state: GameState): GameState {
  return structuredClone(state);
}

export function pruneReceipts(state: GameState, keep = 80): void {
  const entries = Object.entries(state.commandReceipts);
  if (entries.length <= keep) return;
  state.commandReceipts = Object.fromEntries(entries.slice(entries.length - keep));
}

export function stableHash(value: string, seed: number): number {
  let hash = seed | 0;
  for (let index = 0; index < value.length; index += 1) {
    hash = Math.imul(hash ^ value.charCodeAt(index), 0x45d9f3b);
    hash ^= hash >>> 16;
  }
  return hash >>> 0;
}
